import React, { Component } from 'react';
import './App.css';

//Third Party Packages
import {
  Route,
  BrowserRouter
} from "react-router-dom";

// Screens
import Home from './components/Home'
import Apps from './screens/Apps'
import School from './screens/School'
import Projects from './screens/Projects'
import Websites from './screens/Websites'
import Games from './screens/Games'
import Powershades from './screens/PowerShades'
import Midwestern from './screens/Midwestern'
import Invo from './screens/Invo'
import Basspro from './screens/BassPro'

class App extends Component {
   constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <div>
            <Route exact path="/" component={Home}/>
            <Route path="/home" component={Home}/>
            <Route path="/apps" component={Apps}/>
            <Route path="/msu" component={School}/>
            <Route path="/projects" component={Projects}/>
            <Route path="/websites" component={Websites}/>
            <Route path="/games" component={Games}/>
            <Route path="/powershades" component={Powershades}/>
            <Route path="/midwestern" component={Midwestern}/>
            <Route path="/invo" component={Invo}/>
            <Route path="/basspro" component={Basspro}/>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js